/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HoldDateOutcomeStatusEnum } from './HoldDateOutcomeStatusEnum';
import {
    HoldDateOutcomeStatusEnumFromJSON,
    HoldDateOutcomeStatusEnumFromJSONTyped,
    HoldDateOutcomeStatusEnumToJSON,
    HoldDateOutcomeStatusEnumToJSONTyped,
} from './HoldDateOutcomeStatusEnum';

/**
 *
 * @export
 * @interface HoldDateOutcome
 */
export interface HoldDateOutcome {
    /**
     *
     * @type {string}
     * @memberof HoldDateOutcome
     */
    date: string;
    /**
     *
     * @type {HoldDateOutcomeStatusEnum}
     * @memberof HoldDateOutcome
     */
    status: HoldDateOutcomeStatusEnum;
    /**
     *
     * @type {string}
     * @memberof HoldDateOutcome
     */
    holdId: string | null;
    /**
     *
     * @type {string}
     * @memberof HoldDateOutcome
     */
    reason: string | null;
    /**
     *
     * @type {string}
     * @memberof HoldDateOutcome
     */
    message: string;
}



/**
 * Check if a given object implements the HoldDateOutcome interface.
 */
export function instanceOfHoldDateOutcome(value: object): value is HoldDateOutcome {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('holdId' in value) || value['holdId'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function HoldDateOutcomeFromJSON(json: any): HoldDateOutcome {
    return HoldDateOutcomeFromJSONTyped(json, false);
}

export function HoldDateOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoldDateOutcome {
    if (json == null) {
        return json;
    }
    return {

        'date': json['date'],
        'status': HoldDateOutcomeStatusEnumFromJSON(json['status']),
        'holdId': json['hold_id'],
        'reason': json['reason'],
        'message': json['message'],
    };
}

  export function HoldDateOutcomeToJSON(json: any): HoldDateOutcome {
      return HoldDateOutcomeToJSONTyped(json, false);
  }

  export function HoldDateOutcomeToJSONTyped(value?: HoldDateOutcome | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'date': value['date'],
        'status': HoldDateOutcomeStatusEnumToJSON(value['status']),
        'hold_id': value['holdId'],
        'reason': value['reason'],
        'message': value['message'],
    };
}
